import { Flex } from 'theme-ui';
import ArtBoard from './ArtBoard';
import Timeline from './Timeline';
import { ToolBar } from './ToolBar';
import ScenesPanel from './ScenesPanel';
import { ToolPanel } from './ToolPanel';
import CheckoutModal from './CheckoutModal';
import DownloadingModal from './header/DownloadingModal';
import { ShortcutsClipboard } from './shortcuts/ShortcutsClipboard';
import { ShortcutsPopup } from './shortcuts/ShortcutsPopup';
import HeaderLogo from './header/HeaderLogo';
import HeaderExport from './header/HeaderExport';
import { SaveProcessIndicator } from './ProjectFilesBar';
import { ErrorBoundaryModal } from './ErrorBoundaryModal';
import ErrorLogger from './ErrorLogger';

const ErrorBoundary = ErrorLogger.getErrorBoundary();

export const MainContainer = () => (
  <Flex
    sx={{
      height: 'calc(100vh - 16px)',
      flexGrow: 1,
      position: 'relative',
      width: 'calc(100% - 16px)',
      marginLeft: '8px',
      marginTop: '8px',
      boxSizing: 'border-box'
    }}
  >
    <Flex sx={{ flexDirection: 'column' }}>
      <div sx={{ position: 'relative' }}>
        <ErrorBoundary>
          <HeaderLogo />
        </ErrorBoundary>
        <ErrorBoundary>
          <SaveProcessIndicator />
        </ErrorBoundary>
      </div>
      <Flex sx={{ flex: 1 }}>
        <ErrorBoundary>
          <ToolBar />
        </ErrorBoundary>
        <ErrorBoundary>
          <ToolPanel />
        </ErrorBoundary>
      </Flex>
    </Flex>
    <Flex sx={{ flex: '1 1 auto', justifyContent: 'space-between', flexDirection: 'column' }}>
      <ErrorBoundary>
        <ArtBoard />
      </ErrorBoundary>
      <ErrorBoundary>
        <Timeline />
      </ErrorBoundary>
    </Flex>
    <Flex sx={{ flexDirection: 'column' }}>
      <div sx={{ height: '62px', marginBottom: '4px' }} />
      <div sx={{ flex: 1 }}>
        <ErrorBoundary>
          <ScenesPanel />
        </ErrorBoundary>
      </div>
    </Flex>
    <ErrorBoundary>
      <HeaderExport />
    </ErrorBoundary>
    <ErrorBoundary>
      <CheckoutModal />
    </ErrorBoundary>
    <ErrorBoundary>
      <DownloadingModal />
    </ErrorBoundary>
    <ShortcutsClipboard />
    <ErrorBoundary>
      <ShortcutsPopup />
    </ErrorBoundary>
    <ErrorBoundaryModal />
  </Flex>
);
